module.exports = __webpack_public_path__ + "img/积分说明.bd1f931a.png";